// Personalized VIP invitation slugs. Add / edit here to issue new invites.
export const VIP_RECIPIENTS = {
    "jyothi-chettiwar": {
        name: "Jyothi Chettiwar",
        role: "Co-Founder, Carbonis"
    },
    "srikant-kakara": {
        name: "Srikant Kakara",
        role: ""
    },
    "dharanidhar-vemuri": {
        name: "Dharanidhar Vemuri",
        role: "Advisor — AI & IT, Carbonis"
    },
    "devaki-srinath": {
        name: "Devaki Srinath",
        role: "Advisor, Carbonis"
    },
    "sashikant-kakara-vc": {
        name: "Sashikant Kakara",
        role: "VC"
    }
};

export const GENERIC_INVITE = {
    name: "Institutional Partners",
    role: "A private preview for banks, regulators, and prospective partners"
};

export const VIP_STORAGE_KEY = "carbonis:vip-entered";
